import { ArrowRight } from "lucide-react";
import { COMPANY, CONTACT } from "@/data/content";
import { Eyebrow, MaskedLines, Reveal } from "./shared";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="border-t border-softblue bg-mist py-28 md:py-36"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-20">
          <div className="lg:col-span-6">
            <Eyebrow>Contact Us</Eyebrow>
            <h2 className="mt-7 font-serif font-medium leading-[1.02] tracking-tight text-navy">
              <MaskedLines
                lines={[
                  <span key="a" style={{ fontSize: "clamp(2.6rem, 5.6vw, 5.4rem)" }} className="block">
                    CONTACT US<span className="text-brand">.</span>
                  </span>,
                  <span
                    key="b"
                    style={{ fontSize: "clamp(1.7rem, 3vw, 2.8rem)" }}
                    className="mt-3 block font-normal italic text-ink/80"
                  >
                    We&apos;d be glad to hear from you.
                  </span>,
                ]}
              />
            </h2>
            <Reveal delay={0.25}>
              <p className="mt-8 max-w-md text-base leading-relaxed text-fog">
                For product, distribution or business correspondence, reach us
                directly at the address below.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="contact-email-cta"
                className="group mt-10 inline-flex items-center gap-4 border border-brand bg-brand px-9 py-4 text-[11px] font-semibold uppercase tracking-[0.22em] text-white transition-colors duration-300 hover:bg-brand-deep hover:border-brand-deep"
              >
                Email us
                <ArrowRight
                  size={15}
                  className="transition-transform duration-300 group-hover:translate-x-1.5"
                />
              </a>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={0.15} y={40}>
              <div
                className="relative overflow-hidden border border-brand/12 bg-white p-9 md:p-12"
                data-testid="contact-card"
              >
                <div
                  aria-hidden="true"
                  className="absolute -right-20 -top-20 h-56 w-56 rounded-full bg-softblue"
                />
                <div className="relative">
                  <p className="font-serif text-2xl font-semibold tracking-[0.06em] text-navy">
                    {COMPANY.name}
                  </p>

                  <div className="mt-10 border-t border-brand/12 pt-8">
                    <p className="text-[11px] font-semibold uppercase tracking-[0.26em] text-fog">
                      Email
                    </p>
                    <a
                      href={`mailto:${CONTACT.email}`}
                      data-testid="contact-email-link"
                      className="link-underline mt-3 inline-block font-serif text-2xl font-medium text-brand md:text-3xl"
                    >
                      {CONTACT.email}
                    </a>
                  </div>

                  <div className="mt-10 border-t border-brand/12 pt-8">
                    <p className="text-[11px] font-semibold uppercase tracking-[0.26em] text-fog">
                      Corporate Office
                    </p>
                    <address
                      className="mt-4 text-[15px] not-italic leading-relaxed text-ink"
                      data-testid="contact-address"
                    >
                      {CONTACT.officeLines.map((line) => (
                        <span key={line} className="block">
                          {line}
                        </span>
                      ))}
                    </address>
                  </div>

                  <svg
                    aria-hidden="true"
                    viewBox="0 0 200 60"
                    className="mt-10 h-12 w-full text-brand/25"
                    preserveAspectRatio="none"
                  >
                    <g fill="none" stroke="currentColor" strokeWidth="0.7">
                      <path d="M0 45 C 40 20, 70 55, 110 32 S 170 15, 200 28" />
                      <path d="M0 52 C 45 30, 80 60, 120 40 S 175 24, 200 36" strokeDasharray="3 4" />
                    </g>
                    <circle cx="110" cy="32" r="3" fill="#0B5EA8" stroke="none" />
                  </svg>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
